<template>
  <div class="d-sm-flex justify-space-between">
    <div class="words-picker d-flex mx-2 mt-4">
      <label class="mr-2">{{ $t("sankey.moodPicker") }}</label>
      <v-autocomplete
        v-model="pickedMoods"
        :items="allMoodsOfPickedThemes"
        multiple
        clearable
        chips
        deletable-chips
        hide-details
        small-chips
        dense
      ></v-autocomplete>
    </div>
    <div class="words-picker d-flex mx-2 mt-4">
      <label class="mr-2">{{ $t("sankey.motifPicker") }}</label>
      <v-autocomplete
        v-model="pickedMotifs"
        :items="allMotifsOfPickedThemes"
        multiple
        clearable
        chips
        deletable-chips
        hide-details
        small-chips
        dense
      ></v-autocomplete>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    allMoodsOfPickedThemes() {
      return this.$store.state.allMoodsOfPickedThemes;
    },
    allMotifsOfPickedThemes() {
      return this.$store.state.allMotifsOfPickedThemes;
    },
    pickedMoods: {
      get() {
        return this.$store.state.pickedMoods;
      },
      set(value) {
        this.$store.dispatch("updatePickedMoods", value);
      }
    },
    pickedMotifs: {
      get() {
        return this.$store.state.pickedMotifs;
      },
      set(value) {
        this.$store.dispatch("updatePickedMotifs", value);
      }
    }
  }
};
</script>

<style scoped>
.words-picker {
  flex: 1 1 0;
}

.words-picker label {
  white-space: pre;
}
</style>
